import React, { useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { TextArea as MiloTextArea, FormField } from "@justworkshr/milo-form";

import styles from "./TextArea.module.css";
interface ITextAreaProps {
  name: string;
  label: string;
  message?: string;
  placeholder?: string;
  required?: boolean;
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const TextArea = (props: ITextAreaProps): JSX.Element => {
  const {
    name,
    label,
    placeholder,
    message,
    required = true,
    fieldRefs,
  } = props;
  const [field, meta] = useField(props);
  const { setFieldTouched, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (meta.initialTouched === false) {
      setFieldTouched(name, false);
    }
  }, [name, meta.initialTouched, setFieldTouched]);

  return (
    <div
      className={styles.container}
      ref={(el) => {
        if (fieldRefs?.current) {
          fieldRefs.current[name] = el as HTMLInputElement | null;
        }
      }}
    >
      <FormField
        required={required}
        message={message}
        label={label}
        error={meta.touched ? meta.error : ""}
      >
        <MiloTextArea
          className={styles.textArea}
          id={name}
          data-testid={name}
          placeholder={placeholder}
          {...field}
          onBlur={(e) => {
            field.onBlur(e); // Call formik onBlur to trigger validations
            setFieldTouched(name, true);
            setFieldValue(name, e.target.value.trim());
          }}
        />
      </FormField>
    </div>
  );
};

export default TextArea;
